import { render, staticRenderFns } from "./reward_punishment.vue?vue&type=template&id=073eb3fb&scoped=true"
import script from "./reward_punishment.vue?vue&type=script&lang=js"
export * from "./reward_punishment.vue?vue&type=script&lang=js"
import style0 from "./reward_punishment.vue?vue&type=style&index=0&id=073eb3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073eb3fb",
  null
  
)

export default component.exports